import React from 'react';

import { StyleSheet } from 'react-native';

import { Box, Typography } from 'components/ui';
import { getDesignToken, spacing } from 'styles/constants';

export const TableHeader = ({ title, testID }: { title: string; testID?: string }) => {
  return (
    <Box testID={testID} style={styles.wrapper}>
      <Typography variant="headerThree" mb="$1" focusable>
        {title}
      </Typography>
    </Box>
  );
};

const styles = StyleSheet.create({
  wrapper: {
    borderBottomColor: getDesignToken('border-color-default'),
    borderBottomWidth: 1,
    marginBottom: spacing.$4,
    marginTop: spacing.$6,
  },
});
